const prefetched = new Set<string>();

export function prefetchRoute(routeImport: () => Promise<any>) {
  const key = routeImport.toString();
  if (prefetched.has(key)) return;
  prefetched.add(key);

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(() => routeImport().catch(() => {}));
  } else {
    setTimeout(() => routeImport().catch(() => {}), 200);
  }
}

export function prefetchStudentView() {
  prefetchRoute(() => import("@/pages/StudentView"));
}

export function prefetchParentView() {
  prefetchRoute(() => import("@/pages/ParentView"));
}

export function prefetchAdminView() {
  prefetchRoute(() => import("@/pages/AdminView"));
}
